import './bootstrap';
import { createApp, h } from 'vue';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from 'ziggy-js';

const appName = import.meta.env.VITE_APP_NAME || 'VenuePro';

createInertiaApp({
    title: (title) => title ? `${title} - ${appName}` : appName,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .mount(el);
    },
    progress: {
        color: '#4F46E5',
    },
});

// Global error handler for Inertia requests — single consolidated handler
router.on('error', async (event) => {
    const status = event.detail?.response?.status
        || event.detail?.errors?.status;

    if (status === 419) {
        event.preventDefault();

        const refreshed = await window.refreshCsrfToken();

        if (!refreshed) {
            // Session is truly dead — show modal or reload as fallback
            if (typeof window.showSessionExpiredModal === 'function') {
                window.showSessionExpiredModal();
            } else {
                window.location.reload();
            }
        }
        // If refreshed, Inertia will retry on the user's next interaction
    }
});